'use client';

import Link from 'next/link';

import Button from '@/components/ui/Button/Button';

import { ArrowRight } from 'lucide-react';

export default function WhyUs() {
  return (
    <section className='bg-muted/30 px-6 py-16 md:py-24'>
      <div className='mx-auto flex max-w-5xl flex-col items-center justify-between gap-12 lg:flex-row lg:gap-16'>
        {/* Left Visual: Bold Brand Block */}
        <div className='flex w-full items-center lg:w-1/2'>
          {/* Green side accent */}
          <div
            className='h-16 w-[15%] rounded-l-2xl border-2 sm:h-20 lg:h-24'
            style={{ backgroundColor: '#4A7F38', borderColor: '#066653' }}
          />
          {/* Purple middle segment */}
          <div
            className='h-16 w-[25%] border-y-2 border-l-0 sm:h-20 lg:h-24'
            style={{ backgroundColor: '#6A3C9E', borderColor: '#066653' }}
          />
          {/* Main text block */}
          <div
            className='flex h-16 w-[60%] items-center justify-center rounded-r-2xl border-2 text-xl font-black tracking-tight text-white sm:h-20 sm:text-2xl lg:h-24 lg:text-3xl'
            style={{ backgroundColor: '#066653', borderColor: '#066653' }}>
            Bioinfometrics
          </div>
        </div>

        {/* Right Content */}
        <div className='w-full text-center lg:w-1/2 lg:text-left'>
          <p className='text-secondary mb-3 text-[10px] font-black tracking-[0.35em] uppercase'>
            Our Advantage
          </p>
          <h2 className='text-foreground mb-4 text-3xl leading-tight font-black tracking-tight sm:text-4xl lg:text-5xl'>
            Why Bioinfometrics?
          </h2>
          <p className='text-muted-foreground mb-8 text-base leading-relaxed sm:text-lg'>
            We are Biology&apos;s ultimate data-driven storytelling platform. No
            fluff, just the critical insights that drive the bioeconomy forward.
          </p>

          <Link href='/about_us'>
            <Button
              variant='primary'
              className='!px-7 !py-3.5 !text-[12px]'>
              Learn More
              <ArrowRight className='ml-2 inline-block size-4' />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
